import React from 'react';
import { SettingsLink } from '../Navigation';

export default ({ children }) => (
  <div className="pageHeader">
    <SettingsLink />
    {children}
  </div>
);
